import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Typography,
} from '@mui/material';
import { tabs } from './options';
import { Add, Delete } from '@mui/icons-material';

const Subheader = ({ onAdd }) => (
  <Box display="flex" justifyContent="space-between" alignItems="center">
    <ListSubheader sx={{ p: 0 }}>Empresas</ListSubheader>
    <IconButton size="small" onClick={onAdd}>
      <Add fontSize="small" />
    </IconButton>
  </Box>
);

const Sidebar = ({
  tab,
  onAdd,
  setTab,
  pessoal,
  onDelete,
  funcionario,
  setPessoal,
}) => (
  <>
    <Box display="flex" alignItems="center" mb={2} gap={2}>
      <Avatar src={funcionario?.foto} sx={{ width: 64, height: 64 }} />
      <Typography variant="h6">{funcionario?.nome}</Typography>
    </Box>
    <Divider />
    <List dense subheader={<Subheader onAdd={onAdd} />}>
      {funcionario?.Pessoais?.map((p) => (
        <ListItem
          key={p?.id}
          disablePadding
          secondaryAction={
            <IconButton
              edge="end"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onDelete({ rotina: 'Pessoal', id: p?.id });
              }}
            >
              <Delete fontSize="small" />
            </IconButton>
          }
        >
          <ListItemButton
            selected={p?.id === pessoal?.id}
            onClick={() => setPessoal(p)}
          >
            <ListItemText
              primary={p?.empregador}
              secondary={p?.estabelecimento}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
    <Divider />
    <List>
      {tabs?.map(({ name, icon: Icon }, index) => (
        <ListItemButton
          key={name}
          selected={tab === index}
          onClick={() => setTab(index)}
        >
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={name} />
        </ListItemButton>
      ))}
    </List>
  </>
);

export default Sidebar;
